import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  bn: {
    appName: "বাঙালি ইসলামিক ইনস্টিটিউট",
    tagline: "ইলম, ঈমান ও আদব",
    home: "হোম",
    profile: "প্রোফাইল",
    settings: "সেটিংস",
    changePassword: "পাসওয়ার্ড পরিবর্তন",
    register: "রেজিস্ট্রেশন",
    login: "লগইন",
    logout: "লগআউট",
    studentId: "স্টুডেন্ট আইডি",
    name: "নাম",
    email: "ইমেইল",
    phone: "মোবাইল নম্বর",
    address: "ঠিকানা",
    course: "কোর্স",
    edit: "এডিট করুন",
    save: "সেভ করুন",
    cancel: "বাতিল",
    password: "পাসওয়ার্ড",
    confirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
    currentPassword: "বর্তমান পাসওয়ার্ড",
    newPassword: "নতুন পাসওয়ার্ড",
    submit: "জমা দিন",
    welcome: "স্বাগতম",
    menuOurCourses: "আমাদের কোর্সসমূহ",
    menuMyCourses: "আমার কোর্স",
    menuLiveClass: "লাইভ ক্লাস",
    menuVideos: "ক্লাসের ভিডিও",
    menuQuiz: "মাসিক কুইজ",
    menuShop: "অনলাইন শপ",
    menuLibrary: "লাইব্রেরি",
   menuNotifications: "নোটিফিকেশন",
    menuContact: "যোগাযোগ",
    menuComplaint: "অভিযোগ / প্রশ্ন",
    menuDua: "দৈনন্দিন দোয়া ও যিকির",
    menuRewardZone: "ভিডিও দেখে টাকা ইনকাম করুন",
    admin: "এডমিন প্যানেল",
    free: "ফ্রি",
    enroll: "ভর্তি হোন",
    enrolled: "ভর্তি হয়েছেন",
    viewDetails: "বিস্তারিত দেখুন",
    proceedPayment: "পেমেন্টে এগিয়ে যান",
    paymentSuccess: "পেমেন্ট সফল হয়েছে",
    addedToMyCourses: "কোর্সটি আপনার কোর্সে যোগ হয়েছে",
    noData: "কোন ডেটা নেই",
    loading: "লোড হচ্ছে...",
    languageLabel: "ভাষা",
    bengali: "বাংলা",
    english: "ইংরেজি",
    description: "বিবরণ",
    instructor: "শিক্ষক",
    duration: "সময়কাল",
    price: "মূল্য",
    title: "শিরোনাম",
    sendMessage: "বার্তা পাঠান",
    subject: "বিষয়",
    message: "বার্তা",
    submitted: "জমা দেওয়া হয়েছে",
    upcoming: "আসন্ন",
    joinLive: "লাইভে যোগ দিন",
    watchVideo: "ভিডিও দেখুন",
    explore: "এক্সপ্লোর করুন",
    shopComing: "অনলাইন শপ শীঘ্রই আসছে",
    accountInfo: "আপনার তথ্য",
    quickActions: "দ্রুত পদক্ষেপ",
    dontHaveAccount: "অ্যাকাউন্ট নেই?",
    alreadyHaveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    // Actions
    copy: "কপি করুন",
    copied: "কপি হয়েছে!",
    share: "শেয়ার করুন",
    search: "খুঁজুন",
    back: "পেছনে যান",
    close: "বন্ধ করুন",
    hide: "লুকান",
    sending: "পাঠানো হচ্ছে...",
    forgotPassword: "পাসওয়ার্ড ভুলে গেছেন?",
    newFeature: "নতুন ফিচার",
    menu: "মেনু",
    // Pages
    pageNotFound: "পেজটি পাওয়া যায়নি",
    goBack: "আগের পেজে যান",
    goHome: "হোমে যান",
    // Home
    winnersReview: "বিজয়ীদের রিভিউ",
    watchVideoReview: "ভিডিও রিভিউ দেখুন",
    ourSocialMedia: "আমাদের সোশ্যাল মিডিয়া",
    // Contact
    contactUs: "যোগাযোগ করুন",
    socialMedia: "সোশ্যাল মিডিয়া",
    // Dua
    duaCategories: "ক্যাটাগরি",
    duaAllCategories: "সকল ক্যাটাগরি",
    duaTodaysDua: "আজকের দোয়া",
    duaPopular: "সর্বাধিক পঠিত",
    duaRecent: "সাম্প্রতিক",
    duaFavorites: "প্রিয়",
    duaArabic: "আরবি",
    duaTransliteration: "বাংলা উচ্চারণ",
    duaMeaning: "বাংলা অর্থ",
    duaWhenToRead: "কখন পড়তে হয়",
    duaFazilat: "ফজিলত",
    duaSource: "উৎস",
    // Status
    pendingApproval: "অনুমোদনের অপেক্ষায়",
    approved: "অনুমোদিত",
    rejected: "বাতিল",
    active: "সক্রিয়",
    // Live Classes
    liveNow: "এখন চলছে",
    completedClass: "সম্পন্ন",
    joinClass: "ক্লাসে যোগ দিন",
    howToJoin: "কিভাবে যোগ দেবেন?",
    freeClass: "ফ্রি লাইভ ক্লাস",
    myCourseClass: "আমার কোর্স ক্লাস",
    // Videos
    watchOnYouTube: "YouTube-এ দেখুন",
    // Reward
    coinBalance: "কয়েন ব্যালেন্স",
    takaValue: "টাকার মূল্য",
    watchVideosTab: "ভিডিও",
    cashout: "ক্যাশআউট",
    rankingLabel: "র‍্যাংকিং",
    historyLabel: "ইতিহাস",
    // Quiz
    monthlyQuiz: "মাসিক কুইজ",
    startQuiz: "কুইজ শুরু করুন",
    quizStart: "কুইজ শুরু করুন",
    submitQuiz: "সাবমিট করুন",
    myResult: "আপনার ফলাফল",
    quizYourResult: "আপনার ফলাফল",
    leaderboard: "লিডারবোর্ড",
    quizDays: "দিন",
    quizHours: "ঘণ্টা",
    quizMinutes: "মিনিট",
    quizSeconds: "সেকেন্ড",
    // ForgotPassword steps
    fpEmail: "ইমেইল",
    fpOtp: "OTP",
    fpDone: "সম্পন্ন",
    fpSendOtp: "OTP পাঠান →",
    fpResendOtp: "🔄 আবার OTP পাঠান",
    fpChangePassword: "পাসওয়ার্ড পরিবর্তন করুন",
    fpSuccess: "পাসওয়ার্ড পরিবর্তন হয়েছে!",
    fpSuccessDesc: "এখন নতুন পাসওয়ার্ড দিয়ে লগইন করুন।",
  },
  en: {
    appName: "Bengali Islamic Institute",
    tagline: "Knowledge, Faith & Manners",
    home: "Home",
    profile: "Profile",
    settings: "Settings",
    changePassword: "Change Password",
    register: "Register",
    login: "Login",
    logout: "Logout",
    studentId: "Student ID",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    course: "Course",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    password: "Password",
    confirmPassword: "Confirm Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    submit: "Submit",
    welcome: "Welcome",
    menuOurCourses: "Our Courses",
    menuMyCourses: "My Courses",
    menuLiveClass: "Live Class",
    menuVideos: "Class Videos",
    menuQuiz: "Monthly Quiz",
    menuShop: "Online Shop",
    menuLibrary: "Library",
   menuNotifications: "Notifications",
    menuContact: "Contact",
    menuComplaint: "Complaint / Question",
    menuDua: "Daily Duas & Dhikr",
    menuRewardZone: "Earn by Watching Videos",
    admin: "Admin Panel",
    free: "FREE",
    enroll: "Enroll Now",
    enrolled: "Enrolled",
    viewDetails: "View Details",
    proceedPayment: "Proceed to Payment",
    paymentSuccess: "Payment Successful",
    addedToMyCourses: "Course added to your courses",
    noData: "No data yet",
    loading: "Loading...",
    languageLabel: "Language",
    bengali: "Bangla",
    english: "English",
    description: "Description",
    instructor: "Instructor",
    duration: "Duration",
    price: "Price",
    title: "Title",
    sendMessage: "Send Message",
    subject: "Subject",
    message: "Message",
    submitted: "Submitted",
    upcoming: "Upcoming",
    joinLive: "Join Live",
    watchVideo: "Watch Video",
    explore: "Explore",
    shopComing: "Online Shop coming soon",
    accountInfo: "Your Information",
    quickActions: "Quick Actions",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    // Actions
    copy: "Copy",
    copied: "Copied!",
    share: "Share",
    search: "Search",
    back: "Go Back",
    close: "Close",
    hide: "Hide",
    sending: "Sending...",
    forgotPassword: "Forgot Password?",
    newFeature: "New Feature",
    menu: "Menu",
    // Pages
    pageNotFound: "Page Not Found",
    goBack: "Go Back",
    goHome: "Go Home",
    // Home
    winnersReview: "Winner Reviews",
    watchVideoReview: "Watch Video Review",
    ourSocialMedia: "Our Social Media",
    // Contact
    contactUs: "Contact Us",
    socialMedia: "Social Media",
    // Dua
    duaCategories: "Categories",
    duaAllCategories: "All Categories",
    duaTodaysDua: "Today's Dua",
    duaPopular: "Most Read",
    duaRecent: "Recent",
    duaFavorites: "Favorites",
    duaArabic: "Arabic",
    duaTransliteration: "Transliteration",
    duaMeaning: "Meaning",
    duaWhenToRead: "When to Read",
    duaFazilat: "Virtue",
    duaSource: "Source",
    // Status
    pendingApproval: "Pending Approval",
    approved: "Approved",
    rejected: "Rejected",
    active: "Active",
    // Live Classes
    liveNow: "Live Now",
    completedClass: "Completed",
    joinClass: "Join Class",
    howToJoin: "How to Join?",
    freeClass: "Free Live Class",
    myCourseClass: "My Course Classes",
    // Videos
    watchOnYouTube: "Watch on YouTube",
    // Reward
    coinBalance: "Coin Balance",
    takaValue: "Taka Value",
    watchVideosTab: "Video",
    cashout: "Cashout",
    rankingLabel: "Ranking",
    historyLabel: "History",
    // Quiz
    monthlyQuiz: "Monthly Quiz",
    startQuiz: "Start Quiz",
    quizStart: "Start Quiz",
    submitQuiz: "Submit",
    myResult: "Your Result",
    quizYourResult: "Your Result",
    leaderboard: "Leaderboard",
    quizDays: "days",
    quizHours: "hrs",
    quizMinutes: "min",
    quizSeconds: "sec",
    // ForgotPassword steps
    fpEmail: "Email",
    fpOtp: "OTP",
    fpDone: "Done",
    fpSendOtp: "Send OTP →",
    fpResendOtp: "🔄 Resend OTP",
    fpChangePassword: "Change Password",
    fpSuccess: "Password Changed!",
    fpSuccessDesc: "You can now log in with your new password.",
  },
};

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("bii_lang") || "bn");
  useEffect(() => { localStorage.setItem("bii_lang", lang); }, [lang]);
  const t = (k) => dict[lang][k] ?? dict.bn[k] ?? k;
  const pick = (bn, en) => (lang === "bn" ? bn || en : en || bn);
  return (
    <LangContext.Provider value={{ lang, setLang, t, pick }}>{children}</LangContext.Provider>
  );
}
